import React, {ReactNode} from 'react'

export interface ITextProps {
    className?: string
    children?: ReactNode
    onClick?: () => void
    inlineStyle?: any
}

const Text: React.FC<ITextProps> = ({className, children, onClick, inlineStyle}) => {
    return (
        <p onClick={onClick} style={{...inlineStyle}} className={`font-sans ${className}`}>
            {children}
        </p>
    )
}

export default Text
